import { useCallback, useState } from 'react';

import { InfoContentMasInfoDesafio } from './InfoContentMasInfoDesafio';

import { Modal } from '@/components';

export const ModalDesafioMasInformacion = () => {
  const [isModalDesafioOpen, setIsModalDesafioOpen] = useState(false);

  const ModalInfo = useCallback(() => {
    return (
      <>
        <Modal
          controlledOnClose={() => setIsModalDesafioOpen(false)}
          isControlledOpen={isModalDesafioOpen}
          render={() => <InfoContentMasInfoDesafio />}
          size="xs"
          titleClassName="text-lg text-gdt-gray w-full text-center"
          variant="controlled"
        />
      </>
    );
  }, [isModalDesafioOpen]);

  return {
    ModalInfo,
    setIsModalDesafioOpen,
  };
};
